<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?$t('deng-ji-xing-hao'):$t('bian-ji-xing-hao')"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm">
    <!--外部对话框 form-->
    <el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">
      <el-col :span="12">
        <el-form-item :label="$t('xing-hao-dai-ma')" :label-width="formLabelWidth" prop="typeModel">
          <el-input v-model="editForm.typeModel" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('xing-hao-ming-cheng')" :label-width="formLabelWidth" prop="typeName">
          <el-input v-model="editForm.typeName" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('e-ding-gong-shuai')" :label-width="formLabelWidth" prop="ratedPower">
          <el-input v-model="editForm.ratedPower" autocomplete="off"  maxlength="4" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('shu-chu-dian-ya-fan-wei-vdc')" :label-width="formLabelWidth" prop="outputVoltageRange">
          <el-input v-model="editForm.outputVoltageRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('shu-chu-dian-liu-fan-wei-a')" :label-width="formLabelWidth" prop="outputCurrentRange">
          <el-input v-model="editForm.outputCurrentRange" autocomplete="off"  maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="每把枪均充电流范围（A）" :label-width="formLabelWidth" prop="chargingCurrentRangePerGun">-->
      <!--              <el-input v-model="editForm.chargingCurrentRangePerGun" autocomplete="off"></el-input>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <el-col :span="12">
        <el-form-item :label="$t('gong-shuai-fen-pei-fang-shi')" :label-width="formLabelWidth" prop="powerDistributionMode">
          <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.powerDistributionMode">
            <el-option v-for="item in powerDistributionModeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('qiang-xian-chang-du-mi')" :label-width="formLabelWidth" prop="lineLength">
          <el-input v-model="editForm.lineLength" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('chong-dian-qiang-shu-liang')" :label-width="formLabelWidth" prop="gunCount">
          <el-input v-model="editForm.gunCount" autocomplete="off"  maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('shi-fou-dai-guang-gao-ji')" :label-width="formLabelWidth" prop="advertisingMachine">
          <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')" v-model="editForm.advertisingMachine">
            <el-option v-for="item in advertisingMachineData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('mo-kuai-pin-pai-xing-hao')" :label-width="formLabelWidth" prop="moduleBrandModel">
          <el-input v-model="editForm.moduleBrandModel" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('mo-kuai-gong-shuai-kw')" :label-width="formLabelWidth" prop="modularPower">
          <el-input v-model="editForm.modularPower" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('mo-kuai-shu-liang')" :label-width="formLabelWidth" prop="modularCount">
          <el-input v-model="editForm.modularCount" autocomplete="off" maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('zheng-ji-zhong-liang-kg')" :label-width="formLabelWidth" prop="completeMachineWeight">
          <el-input v-model="editForm.completeMachineWeight" autocomplete="off"maxlength="10" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('ruan-jian-ban-ben-hao')" :label-width="formLabelWidth" prop="versionNumber">
          <el-input v-model="editForm.versionNumber" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('dian-liu-qu-jian')" :label-width="formLabelWidth" prop="currentRange">
          <el-input v-model="editForm.currentRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('dian-ya-qu-jian')" :label-width="formLabelWidth" prop="voltageRange">
          <el-input v-model="editForm.voltageRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('gong-shuai-qu-jian')" :label-width="formLabelWidth" prop="powerRange">
          <el-input v-model="editForm.powerRange" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('alaramMonitor.Remarks')" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="editForm.remark" autocomplete="off" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <!--隐藏id-->
      <el-col :span="12">
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearEditForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="mini" plain type="primary" @click.native="editSubmit" :loading="editSubmitLoading">{{ $t('ti-jiao') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {isDecimalThanZero,isInteger} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          typeModel: [{required: true, message: this.$t('zhuang-lei-xing-xing-hao'), trigger: 'blur'}],
          typeName: [{required: true, message: this.$t('zhuang-lei-xing-ming-cheng'), trigger: 'blur'}],
          ratedPower: [{required: true, message: this.$t('e-ding-gong-shuai'), trigger: 'blur'},{validator:isDecimalThanZero,trigger: 'blur'}],
          outputVoltageRange: [{required: true, message: this.$t('shu-chu-dian-ya-fan-wei'), trigger: 'blur'}],
          outputCurrentRange: [{required: true, message: this.$t('shu-chu-dian-liu-fan-wei'), trigger: 'blur'}],
          // chargingCurrentRangePerGun: [{required: true, message: '每把枪均充电流范围', trigger: 'blur'}],
          // powerDistributionMode: [{required: true, message: '功率分配方式', trigger: 'blur'}],
          lineLength: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: this.$t('qing-shu-ru-shu-zi'),
          }],
          gunCount: [{required: true, message: this.$t('chong-dian-qiang-shu-liang-0'), trigger: 'blur'},{validator:isInteger,trigger: 'blur'}],
          // advertisingMachine: [{required: true, message: '是否带广告机', trigger: 'blur'}],
          // moduleBrandModel: [{required: true, message: '模块品牌型号', trigger: 'blur'}],
          modularPower: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: this.$t('qing-shu-ru-shu-zi-0'),
          }],
          modularCount: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: this.$t('qing-shu-ru-shu-zi-1'),
          }],
          completeMachineWeight: [{
            required: false,
            type:'number',
            transform(value) {
              if(value){
                return Number(value);
              }
            },
            message: this.$t('qing-shu-ru-shu-zi-2'),
          }],
          // versionNumber:[{required: true, message: '软件版本号', trigger: 'blur'}],
          // currentRange: [{required: true, message: '电流', trigger: 'blur'}],
          // voltageRange: [{required: true, message: '电压', trigger: 'blur'}],
          // powerRange: [{required: true, message: '功率', trigger: 'blur'}]

        },
        formLabelWidth: '190px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
      powerDistributionModeData:"",
      advertisingMachineData:"",
      editSubmitLoading:false
    },
    methods:{
      clearEditForm(){
        let _this = this
        console.log(this.editForm.id)
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 180px;
      }
    }
  }

  .timeLabOut {
    margin-top: 20px;
    user-select: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .timeLabIn {
    user-select: none;
    width: 100%;
    line-height: 40px;
  }

  .timeLabInCol {
    user-select: none;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .topCheck {
    background-color: rgba(64, 158, 255, 0.6);
  }

  .summitCheck {
    background-color: rgba(103, 194, 58, 0.6);
  }

  .flatCheck {
    background-color: rgba(245, 108, 108, 0.6);
  }

  .valleyCheck {
    background-color: rgba(230, 162, 60, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/add.vue